import {
  FaHtml5,
  FaCss3Alt,
  FaReact,
  FaVuejs,
  FaJava,
  FaNodeJs,
  FaDocker,
  FaFigma,
  FaGitAlt,
} from "react-icons/fa";

import {
  SiSass,
  SiStyledcomponents,
  SiRedux,
  SiNuxtdotjs,
  SiSpringboot,
  SiExpress,
  SiRedis,
  SiMongodb,
  SiMysql,
  SiNetlify,
  SiMui,
  SiFlyway,
  SiJavascript,
  SiTypescript,
  SiWebrtc,
  SiSocketdotio,
} from "react-icons/si";

export const skills = {
  frontend: [
    { id: 1, name: "HTML", icon: FaHtml5 },
    { id: 2, name: "CSS", icon: FaCss3Alt },
    { id: 3, name: "SCSS", icon: SiSass },
    { id: 4, name: "ReactJs", icon: FaReact },
    { id: 5, name: "Styled Components", icon: SiStyledcomponents },
    { id: 6, name: "Hooks", icon: FaReact },
    { id: 7, name: "Redux", icon: SiRedux },
    { id: 8, name: "Vue", icon: FaVuejs },
    { id: 9, name: "Nuxt", icon: SiNuxtdotjs },
    { id: 10, name: "WebSocket", icon: SiSocketdotio },
    { id: 11, name: "WebRTC", icon: SiWebrtc },
  ],

  backend: [
    { id: 1, name: "Java", icon: FaJava },
    { id: 2, name: "Spring Boot", icon: SiSpringboot },
    { id: 3, name: "Flyway", icon: SiFlyway },
    { id: 4, name: "NodeJs", icon: FaNodeJs },
    { id: 5, name: "ExpressJs", icon: SiExpress },
  ],

  others: [
    { id: 1, name: "Redis", icon: SiRedis },
    { id: 2, name: "Docker", icon: FaDocker },
    { id: 3, name: "MongoDB Atlas", icon: SiMongodb },
    { id: 4, name: "MySQL Workbench", icon: SiMysql },
    { id: 5, name: "Figma", icon: FaFigma },
    { id: 6, name: "Netlify", icon: SiNetlify },
    { id: 7, name: "GitHub", icon: FaGitAlt },
    { id: 8, name: "Material UI", icon: SiMui },
  ],

  databases: [
    { id: 1, name: "MySQL", icon: SiMysql },
    { id: 2, name: "MongoDB", icon: SiMongodb },
  ],

  languages: [
    { id: 1, name: "Java", icon: FaJava },
    { id: 2, name: "JavaScript", icon: SiJavascript },
    { id: 3, name: "TypeScript", icon: SiTypescript },
  ],
};
